import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Form, Input, Button, Typography, Alert, Card } from 'antd';

interface LocationState {
  from: {
    pathname: string;
  };
}

export function Login() {
  console.log('🔑 Login: Component rendering');
  
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn } = useAuth();
  const [form] = Form.useForm();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const from = (location.state as LocationState)?.from?.pathname || '/dashboard';

  const handleSubmit = async (values: { email: string; password: string }) => {
    console.log('🔑 Login: handleSubmit called with email:', values.email);
    setError('');
    setLoading(true);
    try {
      await signIn(values.email, values.password);
      console.log('🔑 Login: Sign in successful');
      navigate(from, { replace: true });
    } catch (err) {
      console.error('🔑 Login: Sign in failed:', err);
      setError('Failed to sign in. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  console.log('🔑 Login: Rendering login form');

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Card style={{ width: 400, padding: 24 }}>
        <Typography.Title level={3} style={{ textAlign: 'center' }}>Sign in</Typography.Title>
        {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} />}
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{ email: '', password: '' }}
        >
          <Form.Item
            label="Email Address"
            name="email"
            rules={[{ required: true, message: 'Please enter your email' }]}
          >
            <Input autoComplete="email" autoFocus />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Sign In
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
} 